// @flow

export const isMobile = () => {
  return (
    typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1
  );
};

export const getElementCoords = (elem: HTMLElement) => {
  const box = elem.getBoundingClientRect();

  const body = window.document?.body;
  const docEl = window.document?.documentElement;

  const scrollTop = window.pageYOffset || docEl?.scrollTop || body?.scrollTop;
  const scrollLeft = window.pageXOffset || docEl?.scrollLeft || body?.scrollLeft;

  const clientTop = docEl?.clientTop || body?.clientTop || 0;
  const clientLeft = docEl?.clientLeft || body?.clientLeft || 0;

  const top = box.top + scrollTop - clientTop;
  const left = box.left + scrollLeft - clientLeft;
  const bottom = top + box.height;
  const right = left + box.width;

  return {
    top: Math.round(top),
    left: Math.round(left),
    bottom: Math.round(bottom),
    right: Math.round(right),
  };
};

export const getFullHeight = () => {
  const body = window.document?.body;
  const docEl = window.document?.documentElement;

  return docEl?.scrollHeight || body?.scrollHeight || 0;
};

export const pageWithoutHeader = ['/pronos'];
